<div class="wrapper">
	<app-checkbox
		[label]="params?.value ? 'Yes' : 'No'"
		[model]="params?.value"
		inputCls="checkbox--grid"
		[disabled]="customParams.disabled"
		(modelChange)="toggleValue()"
	></app-checkbox>
</div>
